import React, { useEffect } from 'react';

import InViewObserver from 'components/utility/InViewObserver/InViewObserver';
import TopicFilters from 'components/TopicFilters/TopicFilters';
import { TopicsWithFilters } from 'components/TopicFilters/shared';
import { SalesTypes } from 'context/entityContext';

const TopicfilterContainer: React.FC<any> = (props) => {
  const { setIsTopicFilterInView, topicFilterInView } = props;

  useEffect(() => {
    setIsTopicFilterInView(topicFilterInView);
  }, [setIsTopicFilterInView, topicFilterInView]);

  return <>{props.children}</>;
};

interface IScrolledTopicFilter {
  setIsTopicFilterInView: Function;
  topic: TopicsWithFilters;
  selectedSalesType?: SalesTypes;
  isTimePeriodDisabled: boolean;
}

const ScrolledTopicFilter: React.FC<IScrolledTopicFilter> = (props) => {
  const {
    setIsTopicFilterInView,
    topic,
    selectedSalesType,
    isTimePeriodDisabled,
  } = props;

  return (
    <InViewObserver
      render={({
        scrolledpassed,
      }: {
        scrolledpassed: boolean;
      }): JSX.Element => (
        <div>
          <TopicfilterContainer
            setIsTopicFilterInView={setIsTopicFilterInView}
            topicFilterInView={!scrolledpassed}
          >
            <TopicFilters
              topic={topic}
              selectedSalesType={selectedSalesType}
              isTimePeriodDisabled={isTimePeriodDisabled}
            />
          </TopicfilterContainer>
        </div>
      )}
    />
  );
};

export default ScrolledTopicFilter;
